import { object } from 'prop-types';
import { createPrefixedActionFactory } from './actionUtils';

const prefix = 'HISTORY';
const createAction = createPrefixedActionFactory(prefix);

export const initHistory = createAction({ type: 'INIT_HISTORY' });

export const goTo = createAction({
  type: 'GO_TO',
  propTypes: {
    state: object.isRequired,
  },
});

export const back = createAction({ type: 'BACK' });
